module.exports = __webpack_public_path__ + "static/media/Practice-Area.5503bbe1.jpg";